// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"a0055851","513":"5728588d","703":"5e94e832"}[chunkId] + ".chunk.js";
};